import { isEmpty } from "Util/isEmpty"
import { mergeStrings } from "Util/mergeStrings"
import { searchStringFrom } from "Util/searchStringFrom"

import { Nullable } from "./Nullable"

const DEFAULT_COUNTRY_CODE = '+47'

export type Phone = {
    countryCode: string
    areaCode: null
    phoneNumber: string
    phoneNumberString: string
    searchStrings: {
        countryCode: string
        areaCode: null
        phoneNumber: string
        phoneNumberString: string
    }
}

function getPhoneNumberString(countryCode: string, phoneNumber: string) {
    return mergeStrings(' ', [countryCode, phoneNumber])
}

export function phoneFrom(phoneNumber: string): Nullable<Phone> {
    if (isEmpty(phoneNumber)) {
        return null
    }
    const phoneNumberString = getPhoneNumberString(DEFAULT_COUNTRY_CODE, phoneNumber)
    return {
        countryCode: DEFAULT_COUNTRY_CODE,
        areaCode: null,
        phoneNumber,
        phoneNumberString,
        searchStrings: {
            countryCode: searchStringFrom(DEFAULT_COUNTRY_CODE),
            areaCode: null,
            phoneNumber: searchStringFrom(phoneNumber),
            phoneNumberString: searchStringFrom(phoneNumberString),
        }
    }
}
